import { getDateToday } from "../../../Utils/externalFunctions";
import { filterBetweenDate } from "../../../Utils/FilterItems";

export const filterCutiByDate = (cuti) =>
  cuti.filter(
    filterBetweenDate(
      "tanggal_mulai_cuti",
      "tanggal_selesai_cuti",
      getDateToday("original")
    )
  );

export const filterCutiBySearch = (listCuti, searchFilter) =>
  listCuti?.filter(
    (cuti) =>
      cuti.id_user.toString().toLowerCase().includes(searchFilter) ||
      (cuti.keterangan &&
        cuti.keterangan.toString().toLowerCase().includes(searchFilter)) ||
      (cuti.id_tipe_absensi &&
        cuti.id_tipe_absensi.toString().toLowerCase().includes(searchFilter))
  );

export const convertIdUserToNama = (listCuti, listStaf) => {
  return listCuti?.map((cuti) => {
    const currStaf = listStaf?.find((staf) => cuti.id_user === staf.id);
    return currStaf ? { ...cuti, nama_user: currStaf.nama } : cuti;
  });
};
